// shared/infrastructure/productores.repository.js  (foto decorativa del productor; nunca lanza)
import Api from '../../../../api/global.service';
import env from '../../../../environment';
import { fotoDeParcelas, urlFoto } from '../domain/fotoProductor';

// Promesa por uuid (incluye resultados null): cada productor se consulta una sola vez por sesión.
const fotosCache = new Map();

const toList = body => (Array.isArray(body) ? body : (body && body.data) || []);

export const productoresRepository = {
  /** Foto más reciente del productor: URL absoluta o null (sin parcelas, sin foto o cualquier error). */
  fotoProductor(cuentaUuid) {
    if (!cuentaUuid) return Promise.resolve(null);
    if (!fotosCache.has(cuentaUuid)) {
      const promise = Api.get('parcelas_por_productor', cuentaUuid).then(
        response => {
          const ruta = fotoDeParcelas(toList(response && response.data));
          return ruta ? urlFoto(env.apiURL, ruta) : null;
        },
        () => null
      );
      fotosCache.set(cuentaUuid, promise);
    }
    return fotosCache.get(cuentaUuid);
  },
};

export default productoresRepository;
